/* MDS Birthday Sale: keeps the cart drawer live while the sale is on (SPEC 6d, 7, 14.5). Loaded by
   sections/A-cart-drawer.liquid ONLY while the sale is active; sale off, a-cart-drawer.js runs alone, as today.

   - The drawer's own steppers / remove / add already re-render it from the section HTML (a-cart-drawer.js) and then
     dispatch cart:updated with that response, so those events are left alone.
   - Every other cart:updated (BDS.cart adds from the builder, the quiz, the add-on row, the gift reconcile) carries a
     cart without the drawer's section: the section is fetched once (debounced) and the tracker, the lines, the one
     gift row, the count and the totals all swap in together from that one server render (painting the tracker
     early from JS made it run 1-2s ahead of the lines).
   - "Edit your setup" opens the builder slide-out on the same cart when it is on the page, else follows its link. */
(function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  var sectionId = drawer.dataset.sectionId;
  var timer = null;
  var seq = 0;

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var mine = ++seq;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (mine !== seq || !json || !json[sectionId]) return;   // a newer refresh is on its way
          if (typeof drawer.replaceInner === 'function') drawer.replaceInner(json[sectionId]);
        })
        .catch(function (err) { console.warn('[BDS] cart drawer refresh', err); });
    }, 120);
  }

  document.addEventListener('cart:updated', function (e) {
    var d = e.detail;
    if (d && d.sections && d.sections[sectionId]) return;   // the drawer's own change: already re-rendered from the server
    refresh();
  });

  drawer.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bds-editsetup]');
    if (!a) return;
    var K = window.BDSBuilder;
    if (!K || !K.slideout || typeof K.slideout.open !== 'function') return;   // no slide-out on this page: the link goes to the builder
    e.preventDefault();
    drawer.close();
    K.slideout.open([], { title: 'Build your bundle' });
  });
})();
